import React, { Component } from 'react';

export class Dashboard extends Component {
    render() {
        return (
            <div>
                <div className="jumbotron">
                    <h1>Welcome to Blaze</h1>
                    <p>Blaze is a lightweight CMS designed to help you make blazingly fast edits to your key data.
                        It pares away the fluff of a typical CMS and is tailored to focus on your most critical tasks.
                        If you need more extensive changes, please contact Truebyte. 
                    </p>
                </div>
                <p>To get started, select an option from the menu.</p>
                <p>When you are done, click the <strong>Build Preview</strong> button to see what your site will look like.</p>
            </div>)
    }
}